import { Button } from "@mantine/core";
import { IIssueBoardApi } from "@mcapps/shared";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FailedAlert, McInputNew, MCLoader, McTitle } from "../../../../components";
import { getProjectIdFromUrl } from "../../../utils";
import { usePostProjectByProjectIdIssueboardMoveIssueboardToProjectMutation } from "../../../../../openapi";
import SettingsCardWrapper from "./SettingsCardWrapper";

const MoveIssueBoardToOtherProject: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const [projectNo, setProjectNo] = React.useState<number>();

  const history = useHistory();
  const projectId = getProjectIdFromUrl(history.location.pathname);

  const isProjectValid = howManyCharsIsNumber(projectNo) === 8 || projectNo === 100;

  const [moveIssueBoardToOtherProject, { isError, isLoading, isSuccess }] =
    usePostProjectByProjectIdIssueboardMoveIssueboardToProjectMutation();

  useEffect(() => {
    if (isSuccess === true) {
      history.push(`/project/${projectId}/issues`);
    }
  }, [isSuccess]);

  return (
    <SettingsCardWrapper title={"Flytt register til et annet prosjekt"}>
      {isError && <FailedAlert />}
      {isLoading && <MCLoader />}
      <McTitle style={{ width: "200px" }} title="Oppdragsnummer">
        <McInputNew
          title="Oppdragsnummer"
          type="number"
          value={projectNo}
          onChange={(e) => setProjectNo(Number(e.target.value))}
        />
      </McTitle>
      <Button
        w={"fit-content"}
        mt={"xs"}
        px={"sm"}
        color={!isProjectValid || isLoading ? "lightgray.6" : "green.5"}
        disabled={!isProjectValid || isLoading}
        leftSection={<i className="fa fa-arrow-right fa-fw" />}
        onClick={() =>
          moveIssueBoardToOtherProject({
            projectId: issueBoard.project,
            body: {
              maconomyProjectNo: projectNo,
              issueBoardId: issueBoard._id,
            },
          })
        }
      >
        Flytt register
      </Button>
    </SettingsCardWrapper>
  );
};

export default MoveIssueBoardToOtherProject;

const howManyCharsIsNumber = (num: number | null): number => {
  return num?.toString().length ?? 0;
};
